export default __webpack_public_path__ + "static/media/sbo-grey.44a0d13b.svg";